import { render, staticRenderFns } from "./lang-selector.vue?vue&type=template&id=ea76e21c"
import script from "./lang-selector.vue?vue&type=script&lang=js"
export * from "./lang-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports